var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useRef } from "react";
var StreamContext = createContext(null);
export var StreamProvider = function (_a) {
    var children = _a.children;
    var _b = useState("idle"), status = _b[0], setStatusState = _b[1];
    var _c = useState(null), message = _c[0], setMessageState = _c[1];
    var _d = useState(null), player = _d[0], setPlayer = _d[1];
    var _e = useState({ x: 0, y: 0, width: 0, height: 0 }), videoOffset = _e[0], setVideoOffset = _e[1];
    var connectFnRef = useRef(null);
    var ready = status === "streaming";
    var setStatus = function (newStatus) {
        console.log("[StreamContext] setStatus:", newStatus);
        setStatusState(newStatus);
    };
    var setMessage = function (rawMessage) {
        try {
            var parsedMessage = typeof rawMessage === "string"
                ? JSON.parse(rawMessage)
                : rawMessage;
            setMessageState(parsedMessage);
        }
        catch (error) {
            console.error("Erreur parsing message:", error);
        }
    };
    var sendMessage = function (payload) {
        if (!player || !ready)
            return;
        player.sendUIInteraction(payload);
    };
    var registerConnect = function (fn) {
        connectFnRef.current = fn;
    };
    var connect = function () {
        if (!connectFnRef.current) {
            console.error("[StreamContext] connect() appelé mais aucun connectFn enregistré !");
            return;
        }
        console.log("[StreamContext] connect() → démarrage stream");
        connectFnRef.current();
    };
    return (_jsx(StreamContext.Provider, __assign({ value: {
            status: status,
            setStatus: setStatus,
            message: message,
            setMessage: setMessage,
            player: player,
            setPlayer: setPlayer,
            videoOffset: videoOffset,
            setVideoOffset: setVideoOffset,
            ready: ready,
            sendMessage: sendMessage,
            connect: connect,
            registerConnect: registerConnect,
        } }, { children: children })));
};
export var useStream = function () {
    var ctx = useContext(StreamContext);
    if (!ctx)
        throw new Error("useStream must be used inside StreamProvider");
    return ctx;
};
